import React, { useEffect, useState } from "react";
import { Chart } from "react-google-charts";
import { modalService } from "services";
import { useEffectOnce } from "hooks";
import { fetchWrapper } from "data/FetchWrapper";
import { FA } from "components/FA";
import { Loading, Select } from "components/Utils";
import { statsService } from "services";

const getFlatCategories = (items) => {
  let categories = [];
  for (let item of items) {
    categories.push({ name: item.name, level: item.level });
    if (item.children) {
      categories = categories.concat(getFlatCategories(item.children));
    }
  }
  return categories;
};

const OwnershipEvolution = ({ owners, close }) => {
  const [categories, setCategories] = useState(null);
  const [owner, setOwner] = useState(owners[0].name);
  const [category, setCategory] = useState(null);
  const [stat, setStat] = useState(null);
  useEffectOnce(() => {
    fetchWrapper.get("/api/search/tree").then((categories) => {
      setCategories(getFlatCategories(categories.children));
    });
  });

  useEffect(() => {
    if (owner != null) {
      setStat(null);
      statsService.patents.evolution({ owner, category }).then((stat) => {
        const options = { ...stat.options };
        options.hAxis.title = "Count";
        options.vAxis.title = "Year";
        delete options.hAxis.textPosition;
        delete options.vAxis.textPosition;
        delete options.chartArea;
        options.chartArea = {
          top: 0,
          right: 0,
          width: "85%",
          height: 270,
        };
        delete options.bar;
        setStat({ ...stat, options });
      });
    }
  }, [category, owner]);

  const isLoading = categories == null || stat == null;

  return (
    <>
      <h3 className="card-header">
        Patent Ownership Evolution{" "}
        <FA title="Close" onClick={() => close()} icon="times" size="xs" />
      </h3>
      <div className="card-body">
        <div className="form-row">
          <div className="form-group col-sm">
            <label>Owner</label>
            {owners.length > 1 ? (
              <Select
                uid="oe-owner"
                items={owners}
                value={owner}
                setValue={setOwner}
              />
            ) : (
              <p>{owners[0].name}</p>
            )}
          </div>
          <div className="form-group col-sm">
            <label>Category</label>
            {categories != null ? (
              <Select
                uid="oe-category"
                items={categories}
                empty="Any"
                allowSetEmpty={true}
                value={category}
                setValue={setCategory}
              />
            ) : (
              <Loading />
            )}
          </div>
        </div>

        {isLoading ? (
          <Loading />
        ) : (
          <Chart
            className="chart"
            chartType={stat.chartType}
            data={stat.data}
            options={stat.options}
            width="100%"
            height="320px"
            legendToggle
          />
        )}
      </div>
    </>
  );
};

const openOwnershipEvolutionModal = (owners) =>
  modalService.open({
    id: "stats",
    children: (
      <OwnershipEvolution
        owners={owners}
        close={() => modalService.close("stats")}
      />
    ),
  });

export { openOwnershipEvolutionModal };
